import React from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

interface TagDisplayProps {
  tags: string[]
  maxDisplay?: number
  showCount?: boolean
  variant?: "default" | "secondary" | "destructive" | "outline"
  size?: "sm" | "default"
  className?: string
  onTagClick?: (tag: string) => void
}

export const TagDisplay: React.FC<TagDisplayProps> = ({
  tags,
  maxDisplay = 3,
  showCount = true,
  variant = "secondary",
  size = "sm",
  className,
  onTagClick,
}) => {
  if (!tags || tags.length === 0) {
    return null
  }

  const displayTags = tags.slice(0, maxDisplay)
  const remainingCount = tags.length - maxDisplay

  const badgeClassName = cn(
    size === "sm" && "text-xs py-0.5 px-1.5",
    onTagClick && "cursor-pointer hover:bg-accent",
    className
  )

  return (
    <div className="flex flex-wrap gap-1 items-center">
      {displayTags.map((tag) => (
        <Badge
          key={tag}
          variant={variant}
          className={badgeClassName}
          onClick={() => onTagClick?.(tag)}
        >
          {tag}
        </Badge>
      ))}
      {remainingCount > 0 && showCount && (
        <Badge
          variant="outline"
          className={cn(badgeClassName, "text-muted-foreground")}
        >
          +{remainingCount}
        </Badge>
      )}
    </div>
  )
}

export default TagDisplay
